import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\AssignGravePlotToDossierController::__invoke
* @see app/Http/Controllers/Dossier/AssignGravePlotToDossierController.php
* @route '/api/dossier/{dossier}/grave-plot/{gravePlot}/assign-grave-plot'
*/
const AssignGravePlotToDossierController = (args: { dossier: string | number | { id: string | number }, gravePlot: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, gravePlot: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: AssignGravePlotToDossierController.url(args, options),
    method: 'put',
})

AssignGravePlotToDossierController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/grave-plot/{gravePlot}/assign-grave-plot',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\AssignGravePlotToDossierController::__invoke
* @see app/Http/Controllers/Dossier/AssignGravePlotToDossierController.php
* @route '/api/dossier/{dossier}/grave-plot/{gravePlot}/assign-grave-plot'
*/
AssignGravePlotToDossierController.url = (args: { dossier: string | number | { id: string | number }, gravePlot: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, gravePlot: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            gravePlot: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        gravePlot: typeof args.gravePlot === 'object'
        ? args.gravePlot.id
        : args.gravePlot,
    }

    return AssignGravePlotToDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{gravePlot}', parsedArgs.gravePlot.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\AssignGravePlotToDossierController::__invoke
* @see app/Http/Controllers/Dossier/AssignGravePlotToDossierController.php
* @route '/api/dossier/{dossier}/grave-plot/{gravePlot}/assign-grave-plot'
*/
AssignGravePlotToDossierController.put = (args: { dossier: string | number | { id: string | number }, gravePlot: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, gravePlot: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: AssignGravePlotToDossierController.url(args, options),
    method: 'put',
})

export default AssignGravePlotToDossierController